/** Seconds since the game began, shared by every shader that moves by itself: the crowd, the flashes, the dust. */
export const sceneTime = { value: 0 };

/** How roused the crowd is, 0..1: they jump higher after a big punch and go wild at a knockout. */
export const crowdExcitement = { value: 0 };

/**
 * How far the crowd's bounce has run ahead because they were roused. Summed frame by frame: worked out as
 * time × excitement instead, every change in excitement would throw the whole hall to another point of its bounce, and
 * the later in the evening, the further.
 */
export const crowdBeat = { value: 0 };

/** A burst of camera flashes from the stands after a big moment, 0..1, fading on its own in the show. */
export const flashBurst = { value: 0 };

/** How much faster a fully roused crowd bounces, in radians a second. */
export const cheerTempo = 3;
/** How fast the crowd gets to its feet, in excitement a second. */
const riseRate = 4;

/** Every frame: the crowd rises towards how roused the hall is, sits down with it, and bounces to it. */
export function stirCrowd(roused: number, real: number): void {
  crowdExcitement.value = Math.min(roused, crowdExcitement.value + riseRate * real);
  crowdBeat.value += crowdExcitement.value * cheerTempo * real;
}
